export default function isInternal ({ next, store, nextVue }) {
  const isAuthorized = store.getters['user/user'].user_type === 'Internal';

  if (!isAuthorized) {
    return nextVue({ name: 'error' });
  }

  return next();
}
